import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_SETTLEMENT_LIST_BY_FILTER } from 'containers/SettlementRequest/graphQL';
import {
  Settlement,
  Settlements,
} from 'containers/SettlementRequest/graphQL/types';
import { errorHandler } from 'utils/ErrorHandler';

export function useLazyQueryGetSettlement() {
  const [getSettlement, { loading, refetch }] = useLazyQuery<Settlement>(
    GET_SETTLEMENT_LIST_BY_FILTER,
  );

  const [settlements, setSettlements] = useState<Settlements>();

  const handleGetSettlement = async (invoiceId: string) => {
    try {
      const response = await getSettlement({
        variables: {
          page: 1,
          size: 50,
          filter: {
            hostId: null,
            invoiceIds: [invoiceId],
            taxIds: null,
            uncollected: null,
            unissued: null,
            term: null,
            hasMinusTotalPayment: null,
          },
        },
      });

      if (response) {
        setSettlements(response.data.settlement.settlements);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return {
    settlements,
    isLoading: loading,
    handleGetSettlement,
  };
}
